import { createSlice } from '@reduxjs/toolkit'
import { fetchAllProperties } from '../thunk/siteProperties'

const initialState = {
  loading: false,
  siteProperties: null
}

const sitePropertiesSlice = createSlice({
  name: 'siteProperty',
  initialState: initialState,
  extraReducers: builder => {
    builder
      .addCase(fetchAllProperties.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchAllProperties.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          siteProperties: action.payload
        }
      })
      .addCase(fetchAllProperties.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
  }
})

export default sitePropertiesSlice.reducer
